import { render } from "./SenderInformation.vue?vue&type=template&id=d1be79fa&scoped=true&ts=true"
import script from "./SenderInformation.vue?vue&type=script&lang=ts"
export * from "./SenderInformation.vue?vue&type=script&lang=ts"

import "./SenderInformation.vue?vue&type=style&index=0&id=d1be79fa&scoped=true&lang=css"
import "./SenderInformation.vue?vue&type=style&index=1&id=d1be79fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1be79fa"]])

export default __exports__